import { CMX__SET_BUNDLE } from './types';
import { apiGetBundle } from './api';
import { setLanguageBundle } from '@nackle/intl-tools';

export const isBundleUpdating = (updating) => ({ type: CMX__SET_BUNDLE, updating });

export const getBundle = locale => (dispatch) => {
  dispatch(isBundleUpdating(true));
  apiGetBundle().then(
    (results) => {
      const bundle = results.bundles[locale];
      setLanguageBundle(locale, bundle);
      dispatch(isBundleUpdating(false));
    }
  );
};
